import Vue from 'vue';
import { Message } from 'vhall-ui';
// 全局配置 message 的 offset 值
const offset = 8;

export const $message = options => {
  Message.closeAll(); // 调起新的 message 之前关闭之前 message
  if (typeof options === 'string') {
    options = {
      message: options,
      offset: offset
    };
  }
  options.type = options.type || 'info';
  return Message({
    offset: offset,
    ...options
  });
};

// 重写一遍属性方法,将offset写入options
['success', 'warning', 'info', 'error'].forEach(type => {
  $message[type] = options => {
    Message.closeAll(); // 调起新的 message 之前关闭之前 message
    if (typeof options === 'string') {
      options = {
        message: options,
        offset: offset
      };
    }
    options.type = type;
    return Message({
      offset: offset,
      ...options
    });
  };
});

$message.clear = () => {
  Message.closeAll();
};

// 将$message挂载到this上，用异步任务，是为了能覆盖element自动写入的 $message
const st = setTimeout(() => {
  Vue.prototype.$message = $message;

  Vue.prototype.$msgSuccess = (message, showClose = true, customClass = 'zdy-info-box') => {
    $message({
      message,
      showClose,
      type: 'success',
      customClass
    });
  };

  Vue.prototype.$msgWarning = (message, showClose = true, customClass = 'zdy-info-box') => {
    $message({
      message,
      showClose,
      type: 'warning',
      customClass
    });
  };
  Vue.prototype.$msgInfo = (message, showClose = true, customClass = 'zdy-info-box') => {
    $message({
      message,
      showClose,
      type: 'info',
      customClass
    });
  };

  Vue.prototype.$msgError = (message, showClose = true, customClass = 'zdy-info-box') => {
    $message({
      message,
      showClose,
      type: 'error',
      customClass
    });
  };

  clearTimeout(st);
}, 0);
